var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 23,
    viewBox: "0 0 29 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.271 17.8028V9.06756L14.8164 15.2709L0.816406 7.67498L14.8164 0.0791016L28.8164 7.67498V17.8028H26.271ZM14.8164 22.8668L5.90732 18.056V11.7261L14.8164 16.5368L23.7255 11.7261V18.056L14.8164 22.8668Z",
    fill: "#E82529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdu);
export default __webpack_public_path__ + "static/media/edu.544c69262b86aed454e6edd3424a9b1a.svg";
export { ForwardRef as ReactComponent };